const videoList = [
    {
        id: 23,
        title: 'Hỗ trợ vận hành một người',
        description: 'Một người vận hành máy, với công suất sản xuất tối đa bằng bốn công nhân, đặc biệt phù hợp cho vải có độ đàn hồi cao!',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/knit_fabric.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/knit_fabric.png'
    },
    {
        id: 22,
        title: 'Máy cắt tự động cho vải mềm',
        description: 'Phù hợp với nhiều loại miếng ghép khác nhau, định vị một lần, cắt khi di chuyển.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/nzml01.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/nzml01.png'
    },
    {
        id: 1,
        title: 'Vải đàn hồi',
        description: 'Video vận hành vải đàn hồi, vải dệt kim.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/knit_1.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/knit_1.png'
    },
    {
        id: 2,
        title: 'Vải denim',
        description: 'Video vận hành vải denim.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/cowboy_1.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/cowboy_1.png'
    },
    {
        id: 3,
        title: 'Da',
        description: 'Video vận hành vải da.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/leather_1.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/leather_1.png'
    },
    {
        id: 4,
        title: 'X6-210',
        description: 'Video vận hành thực tế của máy trải X6-210.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/x6_210.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_210.png'
    },
    {
        id: 5,
        title: 'Ngành công nghiệp cho X6',
        description: 'Máy trải X6 phù hợp với nhiều ngành công nghiệp, thiết bị không thể thiếu.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/x6_intro_1.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_intro_1.png'
    },
    {
        id: 6,
        title: 'Công dụng của X6',
        description: 'Máy trải X6 đa năng, thiết bị không thể thiếu.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/x6_intro_2.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_intro_2.png'
    },
    {
        id: 7,
        title: 'Chức năng của máy trải Xiaomai',
        description: 'Máy trải Xiaomai vượt trội, thiết bị không thể thiếu.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/x6_intro_3.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_intro_3.png'
    },
    {
        id: 8,
        title: 'Đặc điểm của máy trải X6',
        description: 'Máy trải X6, máy thân thiện với vải.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/x6_intro_4.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_intro_4.png'
    },
    {
        id: 9,
        title: 'Giới thiệu công ty',
        description: 'Giới thiệu về Công ty Công nghệ Tự động hóa Xiaomai Đông Quản.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/company_intro_1.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/company_intro_1.png'
    },
    {
        id: 10,
        title: 'Xây dựng nhà máy',
        description: 'Giới thiệu về xây dựng nhà máy.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/company_intro_2.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/company_intro_2.png'
    },
    {
        id: 11,
        title: 'Các mẫu khác',
        description: 'Video về máy trải vải.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/spreaders_1.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/spreaders_1.png'
    },
    {
        id: 12,
        title: 'Ngành mũ',
        description: 'Sản xuất trong ngành mũ.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/maozi.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/maozi.png'
    },
    {
        id: 13,
        title: 'Vải dệt',
        description: 'Sản xuất vải dệt.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/suozhimianliao.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/suozhimianliao.png'
    },
    {
        id: 14,
        title: 'Vận hành vải đàn hồi',
        description: 'Video vận hành thực tế của vải đàn hồi.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/tanxing.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/tanxing.png'
    },
    {
        id: 15,
        title: 'Vải lưới',
        description: 'Sản xuất vải lưới.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/wangshamianliao.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/wangshamianliao.png'
    },
    {
        id: 16,
        title: 'Vải dệt kim',
        description: 'Sản xuất vải dệt kim.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/zhenzhimianliao.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/zhenzhimianliao.png'
    },
    {
        id: 17,
        title: 'Giải pháp hoàn hảo cho cuộn mép kép',
        description: 'Giải pháp hoàn hảo cho vải đàn hồi cao với mép cuộn!',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video_center_17.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/video_center_17.png'
    },
    {
        id: 18,
        title: 'Một người vận hành một máy',
        description: 'Một người vận hành một máy, thay thế hoàn toàn hiệu suất của bốn công nhân.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video_center_18.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/video_center_18.png'
    },
    {
        id: 19,
        title: 'Trải mượt mà và không căng',
        description: 'Video trải vải đàn hồi với hiệu ứng mượt mà và không căng.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video_center_19.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/video_center_19.png'
    },
    {
        id: 20,
        title: 'So sánh trải vải',
        description: 'So sánh hiệu quả trải bằng máy và thủ công.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video_center_20.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/video_center_20.png'
    },
    {
        id: 21,
        title: 'Vải bơm',
        description: 'Sản xuất vải bơm.',
        url: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video_center_21.mp4',
        thumbnail: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/video_center_21.png'
    }
];

export default videoList;
